/**
 * Parvus Lightbox
 * Custom styles in assets/styles/wp/_blocks.css to match WP core image block lightbox
 * This file is only loaded on single Tech Classroom posts (classic editor); Parvus is loaded via the jmu-libraries-blocks plugin for gallery blocks
 *
 * @link https://github.com/deoostfrees/Parvus
 */

import Parvus from 'parvus';

window.addEventListener('load', () => {
    // Instantiate Parvus
    // Icon SVG copied from WP core image block lightbox
    const galleryLightbox = new Parvus({ // eslint-disable-line
        selector: '.gallery a',
        gallerySelector: '.gallery',
        lightboxIndicatorIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12"><path fill="#fff" d="M2 0a2 2 0 0 0-2 2v2h1.5V2a.5.5 0 0 1 .5-.5h2V0H2Zm2 10.5H2a.5.5 0 0 1-.5-.5V8H0v2a2 2 0 0 0 2 2h2v-1.5ZM8 12v-1.5h2a.5.5 0 0 0 .5-.5V8H12v2a2 2 0 0 1-2 2H8Zm2-12a2 2 0 0 1 2 2v2h-1.5V2a.5.5 0 0 0-.5-.5H8V0h2Z"></path></svg>',
        closeButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M13 11.8l6.1-6.3-1-1-6.1 6.2-6.1-6.2-1 1 6.1 6.3-6.5 6.7 1 1 6.5-6.6 6.5 6.6 1-1z"></path></svg>'
    });
});
